module.exports = __webpack_public_path__ + "static/img/Pdf.bfead94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Pdf.jpg
// module id = XdTb
// module chunks = 4